<div class="container">
  <form [formGroup]="form">

    <div class="card flex-auto">
      <div class="px-6 py-4 border-b flex items-center header-title">
        <h2 class="title m-0">{{"BANNERS_LIST.NEW_BANNER" | translate}}</h2>
        <div class="flex-end">
          <button [matMenuTriggerFor]="languageFormMenu" mat-icon-button type="button" align="end">
            <mat-icon svgIcon="{{iconFormFlag}}"></mat-icon>
          </button>
          <mat-menu #languageFormMenu="matMenu" overlapTrigger="false">
            <button mat-menu-item (click)="changeFormLanguage('it')">
              <mat-icon svgIcon="flag:italy"></mat-icon>
              <span>Italiano</span>
            </button>
            <button mat-menu-item (click)="changeFormLanguage('en')">
              <mat-icon svgIcon="flag:united-states"></mat-icon>
              <span>English</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <div class="px-6 py-4 flex flex-col">

        <div class="card px-6 py-4 flex flex-col subCards" *ngIf="formLang=='it'">
          <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto">
              <mat-label>{{"BANNERS_LIST.TITLE" | translate}} {{"GLOBAL.ITA" | translate}}</mat-label>
              <input matInput formControlName="nome_it" required>
            </mat-form-field>
            <mat-form-field class="flex-auto">
              <mat-label>{{"BANNERS_LIST.INDEX" | translate}}</mat-label>
              <input matInput type="number" formControlName="index" required>
            </mat-form-field>
            <mat-form-field class="flex-auto">
              <mat-label>Ref</mat-label>
              <mat-select formControlName="langReference" required>
                <mat-option [value]="'IT'">IT</mat-option>
                <mat-option [value]="'EN'">EN</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto">
              <mat-label>{{"BANNERS_LIST.PUBLISH_DATE" | translate}}</mat-label>
              <input [matDatepicker]="datepickerRef" matInput formControlName="startDate" required />
              <mat-datepicker-toggle [for]="datepickerRef" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #datepickerRef></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="flex-auto">
              <mat-label>{{"BANNERS_LIST.EXPIRE_DATE" | translate}}</mat-label>
              <input [matDatepicker]="datepickerRef1" matInput formControlName="endDate" required />
              <mat-datepicker-toggle [for]="datepickerRef1" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #datepickerRef1></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto">
              <mat-label>Redirect url</mat-label>
              <input matInput formControlName="redirectUrl" required>
            </mat-form-field>
            <div class="flex-auto external-url">
              <mat-label>External URL</mat-label>
              <mat-slide-toggle formControlName="externalUrl">
              </mat-slide-toggle>
            </div>
          </div>

          <div class="mt-4 mb-4">
            <h2 class="title mb-2">{{"BANNERS_LIST.DESCRIPTION" | translate}} {{"GLOBAL.ITA" | translate}}</h2>
            <quill-editor formControlName="desc_it" [styles]="{ flex: '1 1 auto' }"></quill-editor>
          </div>
        </div>


        <!-- EN FORM -->
        <div class="card px-6 py-4 flex flex-col subCards" *ngIf="formLang=='en'">
          <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto">
              <mat-label>{{"BANNERS_LIST.TITLE" | translate}} {{"GLOBAL.ENG" | translate}}</mat-label>
              <input matInput formControlName="nome_en" required>
            </mat-form-field>
            <mat-form-field class="flex-auto">
              <mat-label>{{"BANNERS_LIST.INDEX" | translate}}</mat-label>
              <input matInput type="number" formControlName="index" required>
            </mat-form-field>
            <mat-form-field class="flex-auto">
              <mat-label>Ref</mat-label>
              <mat-select formControlName="langReference" required>
                <mat-option [value]="'IT'">IT</mat-option>
                <mat-option [value]="'EN'">EN</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto">
              <mat-label>{{"BANNERS_LIST.PUBLISH_DATE" | translate}}</mat-label>
              <input [matDatepicker]="datepickerRef" matInput formControlName="startDate" required />
              <mat-datepicker-toggle [for]="datepickerRef" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #datepickerRef></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="flex-auto">
              <mat-label>{{"BANNERS_LIST.EXPIRE_DATE" | translate}}</mat-label>
              <input [matDatepicker]="datepickerRef1" matInput formControlName="endDate" required />
              <mat-datepicker-toggle [for]="datepickerRef1" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #datepickerRef1></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto">
              <mat-label>Redirect url</mat-label>
              <input matInput formControlName="redirectUrl" required>
            </mat-form-field>
            <div class="flex-auto external-url">
              <mat-label>External URL</mat-label>
              <mat-slide-toggle formControlName="externalUrl">
              </mat-slide-toggle>
            </div>
          </div>

          <div class="mt-4 mb-4">
            <h2 class="title mb-2">{{"BANNERS_LIST.DESCRIPTION" | translate}} {{"GLOBAL.ENG" | translate}}</h2>
            <quill-editor formControlName="desc_en" [styles]="{ flex: '1 1 auto' }"></quill-editor>
          </div>
        </div>
        <img class="mt-4" style="width: 100px;" [src]="environment.node+'/get-banner-image/'+banner._id" alt="">
        <input type="file" class="mt-4" (change)="onFileSelected($event)" accept="image/*">

        <div class="bottoni">
          <button (click)="confirmClose()" class="m-4">{{"GLOBAL.CLOSE" | translate}}</button>
          <button mat-raised-button (click)="submit()" class="m-4 bottone-viola"
            [disabled]="form.invalid">{{"GLOBAL.EDIT" |
            translate}}</button>
        </div>
      </div>
    </div>
  </form>
</div>
